import React from 'react';
// template components
import InformationalModule from '@nmx/template/dist/componentLibrary/modules/InformationalModule';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// images
import imageDesktopWebp from './images/governance-desktop.webp';
import imageMobileWebp from './images/governance-mobile.webp';

export default () => (
  <InformationalModule
    // configs
    sectionId='sustainability-impact-governance'
    moduleName='financial-planning-module'
    themeType='lightTheme'
    backgroundVariant='lightB'
    reverseContent
    // content
    subHeadingText={<>Earning trust through corporate governance <WidowBlock>and accountability</WidowBlock></>}
    // column content
    columnContentA={(
      <>
        <Typography nextElement='button'>
          We operate ethically, honestly, and transparently to safeguard our policyowners and clients.
        </Typography>
        <Link
          id='sustainability-impact-governance-link'
          variant='buttonLinkSecondary'
          linkUrl='/who-we-are/sustainability-impact/governance/'
          ariaLabel='Find out more about governance and reporting.'>
          Find out more
        </Link>
      </>
    )}
    // image props
    imageAltText='The Chief Distribution Officer talking to people at a networking event'
    imageSrcDefault={imageDesktopWebp}
    imageSrcMobile={imageMobileWebp}
  />
);
